<template>
  <div class="layout-display">
    <div
        v-if="position.enabled"
        :style="layoutManager.getPositionStyle(position.name, true)"
         class="layout-position"
        v-for="position in enabledLayoutPositions"
         :key="position.name">
      <div class="layout-label">{{ $t('vform.' + position.name) }}</div>
      <div v-if="!position.panelId" class="layout-panel-buttons">
        <div class="layout-panel-btn" @click.stop="$emit('createPanel', position.key, false)">{{ $t('vform.createLocalPanel') }}</div>
        <div class="layout-panel-btn" @click.stop="$emit('createPanel', position.key, true)">{{ $t('vform.createGlobalPanel') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LayoutDisplay",
  props: {
    layout: {type: Object, required: true},
    layoutManager: {type: Object, required: true},
  },
  computed: {
    layoutPositions() {
      return this.layout && this.layout.positions ? this.layout.positions : {};
    },
    enabledLayoutPositions() {
      const keys = Object.keys(this.layoutPositions);
      const res = [];
      for (const key of keys) {
        if(this.layoutPositions[key] && this.layoutPositions[key].enabled) {
          res.push({ ...this.layoutPositions[key], key });
        }
      }
      return res;
    }
  },
}
</script>

<style scoped lang="scss">
.layout-display {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  .layout-label {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    background-color: rgba(0,0,0,0.5);
    border-radius: 3px;
    padding: 2px;
  }
  .layout-position {
    .layout-panel-buttons {
      position: absolute;
      bottom: 4px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 4px;
      white-space: nowrap;
      opacity: 0;
      pointer-events: none;
      transition: opacity 150ms ease;
    }
    &:hover .layout-panel-buttons {
      opacity: 1;
      pointer-events: auto;
    }
  }
  .layout-panel-btn {
    background-color: rgba(0, 0, 0, 0.65);
    color: #fff;
    border-radius: 3px;
    padding: 2px 5px;
    font-size: 0.7rem;
    cursor: pointer;
    &:hover {
      background-color: rgba(90, 140, 255, 0.8);
    }
  }
}
</style>